export const environment = {
    API_URL: "https://api.praticaok.com/" //prod
    //API_URL: "https://apipraticaok.quode.it/" //staging
};
